import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const uptimeFilterOperators = unreadonly([
  ...filterOperators.uptime,
  ...filterOperators.empty,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type UptimeFilterOperator = (typeof uptimeFilterOperators)[number];

export type UptimeTableFilter = TableFilterBase & {
  type: 'uptime';
};

export const createUptimeFilter = (): UptimeTableFilter => ({
  type: 'uptime',
  operators: uptimeFilterOperators,
});
